import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useMemo, useCallback } from 'react';
import classnames from 'classnames';
import { Text } from "../../Typography";
import Dropdown from '../Dropdown';
import Option from '../Option';
import ClickOutside from '../../Utils/ClickOutside';
import styles from './Select.scss';

var Select = function Select(_ref) {
  var _classnames5;

  var id = _ref.id,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      defaultValue = _ref.defaultValue,
      value = _ref.value,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
      isDisabled = _ref.isDisabled,
      _ref$closeOnSelect = _ref.closeOnSelect,
      closeOnSelect = _ref$closeOnSelect === void 0 ? true : _ref$closeOnSelect,
      useNativeSelectMenu = _ref.useNativeSelectMenu,
      _ref$dropdownMaxHeigh = _ref.dropdownMaxHeight,
      dropdownMaxHeight = _ref$dropdownMaxHeigh === void 0 ? 'auto' : _ref$dropdownMaxHeigh,
      onChange = _ref.onChange,
      error = _ref.error;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpened = _useState2[0],
      setOpened = _useState2[1];

  var _useState3 = useState(defaultValue),
      _useState4 = _slicedToArray(_useState3, 2),
      localValue = _useState4[0],
      setLocalValue = _useState4[1];

  var isUncontrolled = typeof value === 'undefined';
  var currentValue = isUncontrolled ? localValue : value;
  var isDisableSelect = options.length === 0 || isDisabled;
  var isShowMenu = isOpened && options.length > 0;
  var handleToggleDropdown = useCallback(function () {
    if (!isDisabled) setOpened(function (oldState) {
      return !oldState;
    });
  }, [isDisabled]);
  var handleSelect = useCallback(function (newValue) {
    if (isDisabled) {
      return;
    }

    if (isUncontrolled) setLocalValue(newValue);
    if (onChange) onChange(newValue);
    if (closeOnSelect) setOpened(false);
  }, [isUncontrolled, onChange, closeOnSelect, isDisabled]);
  /**
   * Returns selected option label if exists and default placeholder otherwise.
   */

  var currentValueLabel = useMemo(function () {
    var result = options.find(function (x) {
      return x.value === currentValue;
    });
    return result && result.label;
  }, [currentValue, options]);
  var errorMessage = typeof error === 'string' ? /*#__PURE__*/React.createElement(Text, {
    color: "fail",
    size: "small"
  }, error) : undefined;

  if (useNativeSelectMenu) {
    var _classnames2;

    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
      htmlFor: id,
      className: classnames(styles.select, _defineProperty({}, styles.isOpened, isOpened))
    }, /*#__PURE__*/React.createElement("select", {
      id: id,
      className: classnames(styles.nativeSelect, (_classnames2 = {}, _defineProperty(_classnames2, styles.hasError, !!error), _defineProperty(_classnames2, styles.isOpened, isOpened), _classnames2)),
      disabled: isDisableSelect,
      defaultValue: placeholder
    }, !!placeholder && /*#__PURE__*/React.createElement("option", {
      disabled: true
    }, placeholder), !isDisabled && options.map(function (option) {
      return /*#__PURE__*/React.createElement("option", {
        key: option.value,
        value: option.value
      }, option.label);
    }), isDisabled && /*#__PURE__*/React.createElement("option", {
      selected: true
    }, placeholder)), /*#__PURE__*/React.createElement("div", {
      className: classnames(styles.caret, _defineProperty({}, styles["native"], useNativeSelectMenu))
    })), errorMessage);
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.select, _defineProperty({}, styles.isOpened, isOpened))
  }, /*#__PURE__*/React.createElement("button", {
    className: classnames(styles.trigger, (_classnames5 = {}, _defineProperty(_classnames5, styles.hasError, !!error), _defineProperty(_classnames5, styles.isOpened, isOpened), _classnames5)),
    onClick: handleToggleDropdown,
    type: "button",
    disabled: isDisableSelect
  }, /*#__PURE__*/React.createElement("span", {
    className: classnames(styles.triggerText, _defineProperty({}, styles.triggerText_placeholder, !currentValueLabel && !!placeholder))
  }, currentValueLabel || placeholder), /*#__PURE__*/React.createElement("div", {
    className: styles.caret
  })), isShowMenu && /*#__PURE__*/React.createElement(ClickOutside, {
    onClickOutside: handleToggleDropdown
  }, /*#__PURE__*/React.createElement(Dropdown, {
    maxHeight: dropdownMaxHeight
  }, options.map(function (option) {
    return /*#__PURE__*/React.createElement(Option, {
      key: option.value,
      handleSelect: handleSelect,
      label: option.label,
      value: option.value,
      isSelected: currentValue === option.value,
      isDisabled: option.isDisabled
    }, option.label);
  })))), errorMessage);
};

export default Select;